module.exports = __webpack_public_path__ + "img/W-G41.ff9bf1e4.jpg";